import publish from "./publish";
import survey from "./survey";
import result from "./result";
import analysis from "./analysis";
import percent from "./percent";
import studentModal from "./studentModal";
import teacherModal from "./teacherModal";
import sub from "./sub";
import sub2 from "./sub2";
import sub3 from "./sub3";
import orgScore from "./orgScore";
import comment from "./comment";
import common from "./common";
import swot from "./swot";
import orgAndTargetAnalysis from "./orgAndTargetAnalysis";
import targetAnalysis from "./targetAnalysis";
import collectAnalysis from "./collectAnalysis";
import org from "./org";
import org2 from './org2';
import statistics from "./statistics";
import statistics2 from "./statistics2";
import report from "./report";
import report2 from "./report2";
import reportSchoolType from './reportSchoolType';
import surveyComment from "./surveyComment";
import surveyStatistics from "./surveyStatistics";
import surveyStatistics2 from "./surveyStatistics2";
import surveyGraduateStatistics from "./surveyGraduateStatistics";
import reportTable2 from "./reportTable2";
import groupSurveyStatistics from "./groupSurveyStatistics";
import groupGraduateSurveyStatistics from "./groupGraduateSurveyStatistics";
import reportTable2ByScore from "./reportTable2ByScore";
import reportTable2All from "./reportTable2All";
import reportTable2ByScoreAll from "./reportTable2ByScoreAll";
import reportTable2ByCity from "./reportTable2ByCity";
import reportTable2BySchoolType from "./reportTable2BySchoolType";
import reportTable2ByScoreCity from "./reportTable2ByScoreCity";
import reportTable2ByScoreSchoolType from "./reportTable2ByScoreSchoolType";
import reportTable2ByFixedScore from "./reportTable2ByFixedScore";
import reportTable2ByScoreCity2 from "./reportTable2ByScoreCity2";
import reportTable2ByMajorFixedScore from "./reportTable2ByMajorFixedScore";
import reportAll from "./reportAll";
import reportCity from "./reportCity";
import association from "./association";
import studentComment from "./studentComment";
import studentMultiple from "./studentMultiple";
import assign from "./assign";
import major from "./major";
import majorResult from "./majorResult";
import majorMatchBySchool from "./majorMatchBySchool";

export default {
  publish,
  survey,
  result,
  analysis,
  percent,
  studentModal,
  teacherModal,
  sub,
  sub2,
  sub3,
  orgScore,
  comment,
  common,
  swot,
  orgAndTargetAnalysis,
  targetAnalysis,
  collectAnalysis,
  org,
  org2,
  statistics,
  statistics2,
  report,
  report2,
  reportSchoolType,
  surveyComment,
  surveyStatistics,
  surveyStatistics2,
  surveyGraduateStatistics,
  reportTable2,
  groupSurveyStatistics,
  groupGraduateSurveyStatistics,
  reportTable2ByScore,
  reportTable2All,
  reportTable2ByScoreAll,
  reportTable2ByCity,
  reportTable2BySchoolType,
  reportTable2ByScoreCity,
  reportTable2ByScoreSchoolType,
  reportTable2ByFixedScore,
  reportTable2ByScoreCity2,
  reportTable2ByMajorFixedScore,
  reportAll,
  reportCity,
  association,
  studentComment,
  studentMultiple,
  assign,
  major,
  majorResult,
  majorMatchBySchool
};
